<template>
  <CourseBlock class="achievement">
    <template #title>
      {{ title }}
    </template>

    <template #content>
      <ul class="achievement__list">
        <li
          v-for="(card, i) in slicedCards"
          :key="i"
          class="achievement__item"
        >
          <UiAchievementCard
            :card="card"
            class="achievement__card"
          />
        </li>
      </ul>

      <UiButton
        v-if="cards.length > MAX_SHOWN_CARDS"
        theme="quaternary"
        size="big"
        :stretch="true"
        class="achievement__button"
        @click="isExpanded = !isExpanded"
      >
        {{ isExpanded ? 'Скрыть' : 'Показать ещё' }}
      </UiButton>
    </template>
  </CourseBlock>
</template>

<script setup lang="ts">
  import UiAchievementCard from '@academica-box/components/Cards/UiAchievementCard/UiAchievementCard.vue'
  import UiButton from '@academica-box/components/Buttons/UiButton/UiButton.vue'
  import type { AchievementCard } from '@academica-box/components/Cards/UiAchievementCard/types'
  import CourseBlock from '@/components/CourseBlock.vue'

  const MAX_SHOWN_CARDS = 2

  const props = defineProps<{
    title: string;
    cards: AchievementCard[];
  }>()

  const isExpanded = ref(false)

  const slicedCards = computed(() => {
    return isExpanded.value ? props.cards : [...props.cards].splice(0, MAX_SHOWN_CARDS)
  })
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/UiMedia' as *;
  @use '@academica-box/utils/styles/mixins/UiReset' as *;

  .achievement__list {
    @include ulres;
    display: grid;
    grid-gap: 6px;

    @include media(md, md-max) {
      grid-template-columns: repeat(2, 1fr);
    }

    @include media(xxl) {
      grid-template-columns: repeat(2, 1fr);
    }

    &:not(:last-child) {
      margin-bottom: 20px;

      @include media(lg) {
        margin-bottom: 32px;
      }
    }
  }

  .achievement__card {
    height: 100%;
  }
</style>
